var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show_body)?_c('div',[_c('instructions-sheet',{attrs:{"data_":_vm.data_},on:{"saveData":_vm.saveReportHandle}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }